import type { State } from '../../typings'

export const closeDeleteDialogProducer = (state: State) => ({
  ...state,
  deleteDialogOpened: false,
  underDeletion: undefined,
})
